<div class="report-detail-container">
  <div class="header">
    <button mat-icon-button (click)="goBack()" matTooltip="Back to Reports">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>{{ reportTitle }}</h1>
  </div>

  <div class="report-content">
    <div class="filter-panel">
      <h3>Report Filters</h3>
      <form [formGroup]="filterForm">
        <div class="form-row" *ngFor="let filter of reportFilters; let i = index" [ngSwitch]="filter.type">
          <ng-container *ngIf="!filter.conditional || evaluateConditional(filter.conditional)">
            <!-- Date Filter -->
            <mat-form-field appearance="outline" *ngSwitchCase="'date'">
              <mat-label>{{ getFilterLabel(filter) }}{{ filter.optional ? ' (Optional)' : '' }}</mat-label>
              <input matInput [formControlName]="filter.name!" [matDatepicker]="picker">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <!-- String/Text Filter -->
            <mat-form-field appearance="outline" *ngSwitchCase="'string'">
              <mat-label>{{ getFilterLabel(filter) }}{{ filter.optional ? ' (Optional)' : '' }}</mat-label>
              <input matInput [formControlName]="filter.name!">
            </mat-form-field>

            <!-- Select/Dropdown Filter -->
            <mat-form-field appearance="outline" *ngSwitchCase="'select'">
              <mat-label>{{ getFilterLabel(filter) }}{{ filter.optional ? ' (Optional)' : '' }}</mat-label>
              <mat-select [formControlName]="filter.name!">
                <mat-option *ngFor="let option of filter.options" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Select/Dropdown Filter w/ Search -->
            <mat-form-field appearance="outline" *ngSwitchCase="'selectsearch'">
              <mat-label>{{ getFilterLabel(filter) }}{{ filter.optional ? ' (Optional)' : '' }}</mat-label>
              <mat-select [formControlName]="filter.name!" (openedChange)="!$event && clearSearch(filter.name!)">
                <mat-option disabled class="select-search-option">
                  <input
                    class="select-search-input"
                    placeholder="Search..."
                    [value]="searchTexts[filter.name!] || ''"
                    (input)="searchTexts[filter.name!] = $any($event.target).value"
                    (keydown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()">
                </mat-option>
                <mat-option *ngFor="let option of getFilteredOptions(filter)" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Number Filter -->
            <mat-form-field appearance="outline" *ngSwitchCase="'number'">
              <mat-label>{{ getFilterLabel(filter) }}{{ filter.optional ? ' (Optional)' : '' }}</mat-label>
              <input matInput type="number" [formControlName]="filter.name!">
            </mat-form-field>
          </ng-container>
        </div>

        <div class="form-row" *ngIf="reportMetadata?.cacheable">
          <mat-checkbox formControlName="useCache">Use Cached Data (if available)</mat-checkbox>
        </div>

        <div class="action-buttons">
          <button mat-raised-button color="primary" (click)="generateReport()" [disabled]="!filterForm.valid">
            <mat-icon>play_arrow</mat-icon>
            Generate Report
          </button>
        </div>
      </form>
    </div>

    <div class="report-results" *ngIf="isLoading || responseReceived">
      <div *ngIf="isLoading" class="loading-spinner">
        <mat-spinner></mat-spinner>
        <p>Generating report...</p>
      </div>

      <div class="results-header" *ngIf="!isLoading && reportData?.rows?.length > 0">
        <h3>Report Results</h3>
        <div class="export-buttons">
          <button mat-button (click)="exportCsv()">
            <mat-icon>table_chart</mat-icon>
            Export CSV
          </button>
        </div>
      </div>

      <ng-container *ngIf="!isLoading && reportData?.rows?.length > 0">
        <ng-container *ngIf="reportMetadata.graphs?.length > 0">
          <app-report-graph [reportMetadata]="reportMetadata" [graphData]="graphData"></app-report-graph>
        </ng-container>
        <app-report-table [reportData]="reportData"></app-report-table>
      </ng-container>

      <div *ngIf="!isLoading && reportData?.rows?.length === 0" class="no-data">
        <mat-icon>inbox</mat-icon>
        <p>No data available. Please adjust your filters and generate the report again.</p>
      </div>
    </div>
  </div>
</div>
